import { getQueryParam } from 'reacticoon/routing'
import { Application } from 'reacticoon/archi'
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
} from 'chart.js'

//
// options
//

import modules from './config/modules'
import i18n from './config/i18n'
import routing from './config/routing'
import Content from './config/Content'
import ApiManagerOptions from './config/ApiManagerOptions'
import plugins from './config/plugins'

//
// custom app configuration
//

// Roboto font
import 'typeface-roboto'
import './reset.css'
import './modern-design.css' // 🎨 Modern Design System 2025
import './mobile-responsive-helpers.css' // 📱 Mobile Responsive Helpers

//
// Chart.js configuration - Register required components
//
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
)

//
// IMPORTANT: Détecter le paramètre chlsMigration AVANT toute redirection
//
const MIGRATION_STORAGE_KEY = 'chlsMigration_pending'
if (window.location.search.includes('chlsMigration') || window.location.href.includes('chlsMigration')) {
  localStorage.setItem(MIGRATION_STORAGE_KEY, 'true')
  // Nettoyer l'URL pour ne pas polluer les redirections
  const url = new URL(window.location.href)
  url.searchParams.delete('chlsMigration')
  window.history.replaceState({}, document.title, url.pathname + url.search)
}

//
// IMPORTANT: Détecter le token Discord AVANT d'initialiser l'application
//
const hash = window.location.hash.substring(1)

if (hash && hash.includes('token=')) {
  const params = new URLSearchParams(hash)
  const token = params.get('token')
  
  if (token) {
    // Sauvegarder le JWT
    localStorage.setItem('__session', token)
    
    // Vérification immédiate que le token est bien sauvegardé
    const savedToken = localStorage.getItem('__session')
    if (savedToken) {
      // Nettoyer l'URL (enlever le fragment avec le token)
      window.history.replaceState(null, '', window.location.pathname)
      
      // Rediriger vers le dashboard après connexion Discord
      setTimeout(() => {
        window.location.replace('/')
      }, 200)
    } else {
      // Erreur de sauvegarde du token
      const appOptions = {
        modules,
        i18n,
        plugins,
        routing,
        Content,
        ApiManagerOptions,
      }
      Application(appOptions)
    }
    
    // Ne pas initialiser l'app, on recharge
  } else {
    // Pas de token valide, initialiser l'app normalement
    const appOptions = {
      modules,
      i18n,
      plugins,
      routing,
      Content,
      ApiManagerOptions,
    }
    
    Application(appOptions)
  }
} else {
  // Pas de hash Discord, initialiser l'app normalement
  const appOptions = {
    modules,
    i18n,
    plugins,
    routing,
    Content,
    ApiManagerOptions,
  }
  
  Application(appOptions)
}
